import { useNavigate } from "react-router-dom"; 
import React, { useState, useEffect } from 'react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Select, FormControl, MenuItem } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import Button from '@mui/material/Button';

import LoadingOverlay from 'react-loading-overlay-ts';
import { 
    loadSettings, 
    epochToHumanReadableTS, 
    pretty_print_json, 
    convertLuxonDateTimeToSqlFormat 
} from '../components/Functions'

import axios from 'axios';

import MuiDialogAlert from '../components/MuiDialogAlert';


const columns_alert_data = [
    { field: 'timestamp', headerName: 'Time Stamp', width: 200, headerClassName: 'datagrid_header_default' },
    { field: 'location', headerName: 'Location', width: 200, headerClassName: 'datagrid_header_default' },
    {
        field: 'event', headerName: 'Event', width: 200,
        renderCell: (params) => (
            <div dangerouslySetInnerHTML={{ __html: params.value }} />
        ),
    },
    {
        field: 'data', headerName: 'Data', width: 200,
        renderCell: (params) => (
            <div dangerouslySetInnerHTML={{ __html: params.value }} />
        ),
    }
]

const form_target_list = [
    "device_id",
    "date_1",
    "date_2"
]

const col_space = "10px"

const Alerts = () => {

    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        "device_id": "",
        "date_1": "",
        "date_2": ""
    })
    const [loadingActive, setLoadingActive] = useState(false);
    const [alertTableData, setAlertTableData] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [settings, setSettings] = useState({
        "color_codes": {},
        "map": {},
        "alerts": []
    })
    const [disableLoadBtn, setDisableLoadBtn] = useState(true)    
    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);
    
    const handleClose = () => setShowModal(false);

    const currentDate = DateTime.local();

    useEffect(() => { // Load data on page Start up 

        const getSettings = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getSettings";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });
                console.log(loadSettings(response.data));

                // Set the retrieved data to the state
                setSettings(loadSettings(response.data));
                console.log("Set Setting finished")
                console.log(settings)
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load settings data")
                setShowModal(true) 
            }
        };

        const getDevicesData = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevicesData";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });
                console.log(response.data);
                // Set the retrieved data to the state

                let data = response.data;
                let tmp_array = []
                for (let index = 0; index < data.length; index++) {
                    const d = data[index];
                    let tmp_json = {}
                    tmp_json.device_id = d.device_id;
                    tmp_json.description = d.settings.description
                    tmp_array.push(tmp_json);
                }

                setDeviceList(tmp_array)
                updateFormData("device_id", "all_devices")

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load device settings data")
                setShowModal(true) 
               
            }
        };

        const loadPage = async () => {
            setLoadingActive(true);
            getSettings();
            getDevicesData()
            let val = convertLuxonDateTimeToSqlFormat(currentDate)
            updateFormData("date_1",val)
            updateFormData("date_2",val)
            setLoadingActive(false);
        }

        loadPage()

    }, [])

    useEffect(() => { // Change the type of dates that the user can choose based on the "filter by" 
        if (formData.date_1 !== "" && formData.date_2 !== "") {
            setDisableLoadBtn(false)
        }
    }, [formData.date_1, formData.date_2])

    function updateForm(e) {
        console.log(e)

        if (form_target_list.includes(e.target.id)) {
            updateFormData(e.target.id, e.target.value)
        }

        if (form_target_list.includes(e.target.name)) {
            updateFormData(e.target.name, e.target.value)
        }
        return

    }

    function updateFormDate(id) {
        return function (e, newValue) {
            console.log(id)
            console.log(e);

            let val = convertLuxonDateTimeToSqlFormat(e)
            updateFormData(id, val)
        };
    }

    function updateFormData(id, val) {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: val,
        }));
    }


    function load_btn_click() {
        let url = process.env.REACT_APP_API_SERVER + "/getAlertData";
        let post_data = formData
        post_data.api_user = JSON.parse(localStorage.getItem('user'))

        setLoadingActive(true)

        axios.post(url,post_data)
            .then(function (response) {
                let data = response.data;
                let tmp_array_list = []

                // Create dataset for alert table
                for (let index = 0; index < data.length; index++) {
                    const d = data[index];
                    let msg
                    let tmp_json_list = {}
                    tmp_json_list.id = d.id
                    tmp_json_list.timestamp = epochToHumanReadableTS(d.epoch)
                    tmp_json_list.location = getLocationDescription(d.device_id)

                    if (d.msg === "EMPTY"){
                        msg = "ALERT CLEARED"
                    }
                    else{
                        msg = d.msg
                    }

                    tmp_json_list.event = `
                        <table>
                            <tr>
                                <td width='20px'>
                                    <div style='width:16px; height:16px; border-radius:50%; background-color:${settings.alerts[d.event_id].color_code}; margin-right: 5px;'></div>
                                </td>
                                <td>${msg}</td>
                            </tr>
                        </table>
                    `
                    tmp_json_list.data = JSON.stringify(d.data.vol_data)
                    tmp_array_list.push(tmp_json_list)
                }
                setAlertTableData(tmp_array_list)
                setLoadingActive(false)
            })
            .catch(function (error) {
                // setModalHeader("Error: Unable to Generate Report")
                // setModalBody(error)
                // setShowModal(true)
                setLoadingActive(false)
            });

    }

    function getLocationDescription(device_id) {
        for (var i = 0; i < deviceList.length; i++) {
            if (deviceList[i].device_id === device_id) {
                return deviceList[i].description
            }
        }
    }

    function alertsDataRowClick(e) {
        console.log(e)

        let data_json = e.row.data
        let tmp_html = `
        <div><b>LOCATION</b></div>
        <div>${e.row.location}</div>        
        <div><b>Data</b></div>
        <div>
        <pre>${pretty_print_json(data_json)}</pre>
        </div>        
        `
        console.log(tmp_html)
        setModalHeader(e.row.timestamp)
        setModalHtml(tmp_html)
        setShowModal(true)

    }


    return (
        <main>
            <div align="left" style={{ height: "100%" }}>
                <LoadingOverlay
                    active={loadingActive}
                    spinner
                    text="Loading ..."
                    className="spinner_div"
                >
                <div className='page_title'>Alerts</div>

                    <div>
                        <table>
                            <tr>
                                {/* Select: Device */}
                                <td width="150px">
                                    <div className="form-labels">Device</div>
                                    <FormControl fullWidth>
                                        <Select
                                            id="device_id"
                                            name="device_id"
                                            label="Select Device"
                                            value={formData.device_id}
                                            variant="outlined"
                                            onChange={updateForm}
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                ' & .MuiSelect-select': { backgroundColor: "#FFFFFF", fontSize: 14 }
                                            }}
                                        >
                                            <MenuItem key="all_devices" value="all_devices">
                                                All Devices
                                            </MenuItem>
                                            {
                                                deviceList.map(device => {
                                                    return <MenuItem key={device.device_id} value={device.device_id}>
                                                        {device.description}
                                                    </MenuItem>
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </td>
                                <td width={col_space}></td>
                                {/* DatePicker: Date_1 */}
                                <td>
                                    <div className="">
                                        <div className="form-labels">From Date</div>
                                        <DatePicker
                                            id="date_1"
                                            name="date_1"
                                            type="date"
                                            views={['year', 'month', 'day']}
                                            onChange={updateFormDate("date_1")}
                                            defaultValue={currentDate}
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                '& .MuiInputBase-root': { backgroundColor: "#FFFFFF", fontSize: 14 }
                                            }}
                                        />
                                    </div>
                                </td>
                                <td width={col_space}></td>
                                {/* DatePicker: Date_2 */}
                                <td>
                                    <div className="">
                                        <div className="form-labels">To Date</div>
                                        <DatePicker
                                            id="date_2"
                                            name="date_2"
                                            type="date"
                                            views={['year', 'month', 'day']}
                                            onChange={updateFormDate("date_2")}
                                            defaultValue={currentDate}
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                '& .MuiInputBase-root': { backgroundColor: "#FFFFFF", fontSize: 14 }
                                            }}
                                        />
                                    </div>
                                </td>
                                <td width={col_space}></td>
                                {/* Button: Load */}
                                <td>
                                    <div style={{ paddingTop: 28 }}>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={load_btn_click}
                                            sx={{
                                                width: 100,
                                                height: 50,
                                                "&.Mui-disabled": {
                                                    background: "#ffffff4d"
                                                }
                                            }}
                                            disabled={disableLoadBtn}
                                        >
                                            Load
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div style={{ height: "20px" }}></div>
                    <div style={{ height: "1px", backgroundColor: "#FFFFFF", width: "1200px" }}></div>
                    <div style={{ height: "20px" }}></div>

                    <div className='data_container'>
                        <div className='data_container_header'>
                            Alerts
                        </div>
                        <div className='datagrid_content'>
                            <div style={{ width: "100%" }}>
                                <DataGrid
                                    className='datagrid_default'
                                    rows={alertTableData}
                                    columns={columns_alert_data}
                                    pageSize={50}
                                    onRowClick={alertsDataRowClick}
                                    disableVirtualization
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                    sx={{
                                        '& .MuiTablePagination-selectLabel': {
                                            paddingTop: '15px'

                                        },
                                        '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                        '& .MuiDataGrid-cell': { fontSize: 14 },
                                        '& .MuiDataGrid-columnHeader': {
                                            fontSize: 16,
                                            color: '#1B9982',
                                            fontWeight: 900
                                        },
                                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                            outline: 'none', // Remove outline when cell is focused or editing
                                            border: 'none', // Remove border when cell is focused or editing
                                        },
                                        '& .MuiDataGrid-root': {
                                            border: 'none'
                                        },
                                        '& .MuiButton-root, & .MuiButtonBase-root': {
                                            color: '#1B9982', // Change this to your desired color
                                        },
                                        '& .MuiTablePagination-root': {
                                            color: '#FFFFFF', // Change this to your desired color
                                        },


                                    }} />
                            </div>
                        </div>
                    </div>

                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        html={modalHtml}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />
                </LoadingOverlay>
            </div>
        </main>
    )
}
export default Alerts